import { Box } from "@mui/material"
import { useSelector } from "react-redux"
import ProfessionalsTable from "./ProfessionalsTable"

// TODO: Remove centerId from props as now the center selection is handled in the navbar
const DisplayProfessionals = () => {
  const centerId = useSelector(({ center }) => center)?.data?.id

  return (
    <Box mt={4} sx={{ minWidth: "100%" }}>
      {centerId && <ProfessionalsTable centerId={centerId} />}
    </Box>
  )
}

export default DisplayProfessionals